var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapArrowHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29307",
    "data-name": "Group 29307",
    transform: "translate(-1307 11303.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(1307 -11303.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29289",
    "data-name": "Group 29289",
    transform: "translate(715 -11609.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49706",
    "data-name": "Path 49706",
    d: "M23.972,48a.154.154,0,0,1-.036-.064L21.454,40.2a2.84,2.84,0,0,0-1.837-1.837L11.88,35.882a.154.154,0,0,1-.064-.036.159.159,0,0,1-.035-.145.134.134,0,0,1,.1-.1L30,29.63a.149.149,0,0,1,.188.188l-5.969,18.12a.134.134,0,0,1-.1.1A.157.157,0,0,1,23.972,48Z",
    transform: "translate(597.223 284.378)",
    fill: "#00d7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49707",
    "data-name": "Path 49707",
    d: "M24.125,198.433l-9.77-.959,7.342,2.857a2.425,2.425,0,0,1,1.533,1.6l2.474,8.059-.657-10.6A1.01,1.01,0,0,0,24.125,198.433Z",
    transform: "translate(594.703 122.777)",
    fill: "#30c7f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49708",
    "data-name": "Path 49708",
    d: "M289.045,41.167l5.969-18.12a.6.6,0,0,0-.148-.624l-7.8,7.652c.17.17.142.675.157.915l.659,10.173A.611.611,0,0,0,289.045,41.167Z",
    transform: "translate(332.524 291.606)",
    fill: "#00aadf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapArrowHighlighted);
export default __webpack_public_path__ + "static/media/map-arrowHighlighted.e23f50baa26766a01515e9bc08be3f00.svg";
export { ForwardRef as ReactComponent };